import { ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { DOC_SLUGS, docHref, getDocPage } from "@/content/docs/index";

/** Previous / next through the flat reading order across all sections. */
export function DocPager({ slug }: { slug: string }) {
  const order = DOC_SLUGS.filter((s) => getDocPage(s));
  const index = order.indexOf(slug);
  if (index < 0) return null;

  const prev = index > 0 ? getDocPage(order[index - 1] as string) : undefined;
  const next = index < order.length - 1 ? getDocPage(order[index + 1] as string) : undefined;
  if (!prev && !next) return null;

  return (
    <nav
      className="mt-14 flex flex-col gap-3 border-t border-border pt-8 sm:flex-row sm:justify-between"
      aria-label="Documentation pages"
    >
      {prev ? (
        <Link
          to={docHref(prev.slug)}
          rel="prev"
          className="group flex flex-col gap-1 text-sm sm:max-w-[48%]"
        >
          <span className="inline-flex items-center gap-1 text-muted-foreground">
            <ArrowLeft className="h-3.5 w-3.5" aria-hidden /> Previous
          </span>
          <span className="font-medium text-foreground group-hover:text-primary">
            {prev.navLabel ?? prev.title}
          </span>
        </Link>
      ) : (
        <span />
      )}
      {next ? (
        <Link
          to={docHref(next.slug)}
          rel="next"
          className="group flex flex-col gap-1 text-sm sm:ml-auto sm:max-w-[48%] sm:text-right"
        >
          <span className="inline-flex items-center gap-1 text-muted-foreground sm:justify-end">
            Next <ArrowRight className="h-3.5 w-3.5" aria-hidden />
          </span>
          <span className="font-medium text-foreground group-hover:text-primary">
            {next.navLabel ?? next.title}
          </span>
        </Link>
      ) : null}
    </nav>
  );
}
